export default "__VITE_ASSET__BLtgqW_D__"